//#region > Imports
//> React
// Contains all the functionality necessary to define React components
import { MDBAnimation, MDBBtn, MDBIcon } from "mdbreact";
import moment from "moment";
import { Component } from "react";
//> Animations
import { animations } from "react-animation";

//> Components

//#endregion

//#region > Config
/**
 * Nebensaison Blau = 0
 * Nebensaison Orange = 1
 * Hauptsaison Blau = 2
 * Hauptsaison Orange = 3
 * Bikeweek = 4
 */

const seasons = {
  ns: {
    id: "N",
    keys: ["NB, NO"], // Nebensaison Blau, Nebensaison Orange
    dateRange: ["23.04.", "01.07.", "13.09.", "30.09."],
  },
  hs: {
    id: "H",
    keys: ["HB, HO"], // Hauptsaison Blau, Hauptsaison Orange
    dateRange: ["01.07.", "05.09."],
  },
  bw: {
    id: "bw",
    keys: ["BW"], // Bikeweek
    dateRange: ["05.09.", "13.09."],
  },
};

const matrix = [
  {
    id: "NB",
    data: {
      adults: 12,
      children: 11,
      basicPlace: 16, // Stellplatz
      dog: 6,
      extraCar: 6,
      minPrice: 0,
      bikeWeek_carOrTrailer: null,
      bikeWeek_caravan: null,
      bikeWeek_xxlCaravan: null,
      bikeWeek_xxlCamper: null,
    },
  },
  {
    id: "NO",
    data: {
      adults: 12,
      children: 11,
      basicPlace: 20, // Stellplatz
      dog: 6,
      extraCar: 6,
      minPrice: 0,
      bikeWeek_carOrTrailer: null,
      bikeWeek_caravan: null,
      bikeWeek_xxlCaravan: null,
      bikeWeek_xxlCamper: null,
    },
  },
  {
    id: "HB",
    data: {
      adults: 13,
      children: 12,
      basicPlace: 24,
      dog: 6,
      extraCar: 6,
      minPrice: 0,
      bikeWeek_carOrTrailer: null,
      bikeWeek_caravan: null,
      bikeWeek_xxlCaravan: null,
      bikeWeek_xxlCamper: null,
    },
  },
  {
    id: "HO",
    data: {
      adults: 13,
      children: 12,
      basicPlace: 24,
      dog: 6,
      extraCar: 6,
      minPrice: 55,
      bikeWeek_carOrTrailer: null,
      bikeWeek_caravan: null,
      bikeWeek_xxlCaravan: null,
      bikeWeek_xxlCamper: null,
    },
  },
  {
    id: "BW",
    data: {
      adults: 25,
      children: 15,
      basicPlace: null,
      dog: 6,
      extraCar: null,
      minPrice: 0,
      bikeWeek_carOrTrailer: 15,
      bikeWeek_caravan: 30,
      bikeWeek_xxlCaravan: 40,
      bikeWeek_xxlCamper: 50,
    },
  },
];

/**
 * Q1: Saison -> Auswahl
 * Q2: Personen Anzahl (10+, 3-9, 0-2)
 * Q3: Platzwahl (Blau oder Orange)
 * Q4: Wie viel Stellplätze (Only non bikeweek)
 * Q5: Hund (Only non bikeweek)
 * Q6: Zusatz Parkplätze (Only non bikeweek)
 * Q7: Auto oder Hänger / Caravaan oder XXL Caravaan (Bikeweek)
 */
//#endregion

//#region > Config
const lang = {
  de: [
    ["Schritt zurück", "Neu berechnen"],
    [
      "Anreisezeitraum",
      "Wähle deinen Anreisezeitraum aus",
      "Nebensaison Frühjahr",
      "Hauptsaison",
      "Arneitz Bike Show",
      "Nebensaison Spätsommer",
    ],
    [
      "Jugendliche",
      "10–17 Jahre",
      "Erwachsene",
      "ab 18 Jahre, zzgl. 4,50€ Aufenthaltsabgabe/Nacht",
      "Kinder",
      "Zwischen 3 und 9 Jahre alt",
      "Hunde",
      "",
      "Weiter",
    ],
    [
      "Zone Blau",
      "Stellplätze nahe Eingangsbereich",
      "Zone Orange",
      "Stellplätze in Seenähe",
    ],
    [
      "Stellplätze",
      "Plätze am Campingplatz",
      "Zusätzliche PKWs",
      "Parkplätze vor dem Campingplatz",
      "Berechnen",
    ],
    [
      "Dein Aufenthalt bei Camping Arneitz kostet",
      "pro Nacht",
      "Preis inkl. Aufenthaltsabgabe (Ortstaxe); 4,50€/Nacht pro Erwachsener",
    ],
    [
      "Zusätzliche Fahrzeuge?",
      "Fahrzeug oder Anhänger bis 5m",
      "z.B. Auto oder Anhänger",
      "Fahrzeug bis 6.9m",
      "z.B. Caravan",
      "Fahrzeug ab 7m",
      "z.B. XXL Caravan",
      "Camper XXL ab 10m",
      "z.B. Camper XXL",
      "Berechnen",
    ],
  ],
  en: [
    ["Previous step", "Recalculate"],
    [
      "Date of arrival",
      "Choose your date of arrival",
      "Off-Season Spring",
      "Main-Season",
      "Bike Show",
      "Off-Season Fall",
    ],
    [
      "Teenagers (10–17 years)",
      "10–17 years",
      "Adults (18+)",
      "plus €4.50 local tax/night",
      "Children",
      "Between 3 and 9 Years",
      "Dogs",
      "",
      "Next",
    ],
    [
      "Zone Blue",
      "Parking Spaces near entrance",
      "Zone Orange",
      "Parking Spaces near the lake",
    ],
    [
      "Parking Spaces",
      "Spaces on the Campsite",
      "Extra cars",
      "Parking Spaces in front of the Campsite",
      "Calculate",
    ],
    [
      "Your stay at Camping Arneitz costs",
      "per Night",
      "Price incl. local tax; €4.50/night per adult",
    ],
    [
      "Additional vehicles?",
      "Vehicle or trailer up to 5m",
      "Car or trailer, ...",
      "Vehicle up to 6.9m",
      "Caravan, ...",
      "Vehicle from 7m",
      "XXL Caravan, ...",
      "Camper XXL from 10m",
      "XXL Camper, ...",
      "Calculate",
    ],
  ],
};

const stylePopIn = {
  animation: animations.popIn,
};
//#endregion

//#region > Components
class App extends Component {
  state = {
    step: 0,
    season: undefined,
    zone: undefined,
    isBikeWeek: false,
    bikeWeekSelection: undefined,
    adultsTeen: 0,
    adults18: 1,
    children: 0,
    babies: 0,
    basicPlaces: 1,
    extraCar: 0,
    dogs: 0,
    carOrTrailer: 0,
    caravan: 0,
    xxlCaravan: 0,
    xxlCamper: 0,
  };

  calculate = () => {
    const {
      season,
      zone,
      isBikeWeek,
      bikeWeekSelection,
      adultsTeen,
      adults18,
      children,
      basicPlaces,
      extraCar,
      dogs,
      carOrTrailer,
      caravan,
      xxlCaravan,
      xxlCamper,
    } = this.state;

    if (!isBikeWeek && !bikeWeekSelection) {
      // Get id of season
      const slug = season.id + zone;

      // Get season
      const selectedItem = matrix.filter((item) => item.id === slug)[0].data;

      const calc = {
        adults: (adultsTeen + adults18) * selectedItem.adults,
        basicPlace: basicPlaces * selectedItem.basicPlace,
        children: children * selectedItem.children,
        dogs: dogs * selectedItem.dog,
        extraCars: extraCar * selectedItem.extraCar,
      };

      let finalPrice = 0;

      const calcPrice = calc.adults + calc.basicPlace + calc.children;

      if (calcPrice < selectedItem.minPrice) {
        finalPrice = selectedItem.minPrice;
      } else {
        finalPrice = calcPrice;
      }

      finalPrice += calc.dogs + calc.extraCars;

      // Apply local tax for adults 18+ (per night), not during Bike Show
      const localTax = adults18 * 4.5;
      finalPrice += localTax;

      this.setState({
        price: finalPrice,
      });
    } else {
      const selectedItem = matrix.filter((item) => item.id === "BW")[0].data;

      const calc = {
        // During Bike Show: 10–17 at €20, 18+ at selectedItem.adults (€25)
        adults: adultsTeen * 20 + adults18 * selectedItem.adults,
        children: children * selectedItem.children,
        dogs: dogs * selectedItem.dog,
      };

      let finalPrice = 0;

      const calcPrice =
        calc.adults +
        calc.children +
        carOrTrailer * selectedItem.bikeWeek_carOrTrailer +
        caravan * selectedItem.bikeWeek_caravan +
        xxlCaravan * selectedItem.bikeWeek_xxlCaravan +
        xxlCamper * selectedItem.bikeWeek_xxlCamper;

      finalPrice = calcPrice + calc.dogs;

      this.setState({
        price: finalPrice,
      });
    }
  };

  render() {
    const url = window.location.href;

    const selectedLanguage = url.includes("/en") ? lang.en : lang.de;
    const locale = "de-AT";

    return (
      <div className="flex-center">
        <div>
          {this.state.step !== false && this.state.step !== 0 && (
            <div className="text-center mb-3">
              <span
                className="text-muted clickable"
                onClick={() =>
                  this.setState({
                    step: this.state.step === 4 ? 1 : this.state.step - 1,
                  })
                }
              >
                <MDBIcon icon="angle-left" /> {selectedLanguage[0][0]}
              </span>
            </div>
          )}
          {this.state.step === false && (
            <div className="text-center mb-3">
              <span
                className="text-muted clickable"
                onClick={() => this.setState({ step: 0 })}
              >
                <MDBIcon icon="redo-alt" /> {selectedLanguage[0][1]}
              </span>
            </div>
          )}
          <div>
            {(() => {
              switch (this.state.step) {
                case 0:
                  return (
                    <div>
                      <div className="pb-2 text-center" style={stylePopIn}>
                        <p className="font-weight-bold">
                          {selectedLanguage[1][0]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[1][1]}
                        </p>
                      </div>
                      <span
                        className="btn btn-primary d-block animated"
                        onClick={() =>
                          this.setState({ step: 1, season: seasons.ns })
                        }
                        style={{ animation: `${animations.popIn} 100ms` }}
                      >
                        <p className="font-weight-bold">
                          {selectedLanguage[1][2]}
                        </p>
                        <p>
                          {seasons.ns?.dateRange[0]} -{" "}
                          {seasons.ns?.dateRange[1]}
                        </p>
                      </span>
                      <span
                        className="btn btn-primary d-block animated"
                        onClick={() =>
                          this.setState({ step: 1, season: seasons.hs })
                        }
                        style={{ animation: `${animations.popIn} 200ms` }}
                      >
                        <p className="font-weight-bold">
                          {selectedLanguage[1][3]}
                        </p>
                        <p>
                          {seasons.hs?.dateRange[0]} -{" "}
                          {seasons.hs?.dateRange[1]}
                        </p>
                      </span>
                      <span
                        className="btn btn-primary d-block animated"
                        onClick={() =>
                          this.setState({ step: 1, season: seasons.bw })
                        }
                        style={{ animation: `${animations.popIn} 300ms` }}
                      >
                        <p className="font-weight-bold">
                          {selectedLanguage[1][4]}
                        </p>
                        <p>
                          {seasons.bw?.dateRange[0]} -{" "}
                          {seasons.bw?.dateRange[1]}
                        </p>
                      </span>
                      <span
                        className="btn btn-primary d-block animated"
                        onClick={() =>
                          this.setState({ step: 1, season: seasons.ns })
                        }
                        style={{ animation: `${animations.popIn} 400ms` }}
                      >
                        <p className="font-weight-bold">
                          {selectedLanguage[1][5]}
                        </p>
                        <p>
                          {seasons.ns?.dateRange[2]} -{" "}
                          {seasons.ns?.dateRange[3]}
                        </p>
                      </span>
                    </div>
                  );
                case 1:
                  return (
                    <div className="text-center">
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[2][2]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[2][3]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.adults18 <= 1 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                adults18:
                                  this.state.adults18 > 1
                                    ? this.state.adults18 - 1
                                    : 1,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">{this.state.adults18}</span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.adults18 >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                adults18:
                                  this.state.adults18 < 26
                                    ? this.state.adults18 + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[2][0]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[2][1]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.adultsTeen <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                adultsTeen:
                                  this.state.adultsTeen > 0
                                    ? this.state.adultsTeen - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">
                          {this.state.adultsTeen}
                        </span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={
                              this.state.adultsTeen >= 26 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                adultsTeen:
                                  this.state.adultsTeen < 26
                                    ? this.state.adultsTeen + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[2][4]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[2][5]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.children <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                children:
                                  this.state.children > 0
                                    ? this.state.children - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">{this.state.children}</span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.children >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                children:
                                  this.state.children < 26
                                    ? this.state.children + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[2][6]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[2][7]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.dogs <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                dogs:
                                  this.state.dogs > 0 ? this.state.dogs - 1 : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">{this.state.dogs}</span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.dogs >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                dogs:
                                  this.state.dogs < 26
                                    ? this.state.dogs + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                        <div className="mt-3">
                          <span
                            className="btn btn-primary"
                            onClick={() =>
                              this.setState({
                                step: this.state.season?.id !== "bw" ? 2 : 4,
                                isBikeWeek: this.state.season?.id === "bw",
                              })
                            }
                          >
                            {selectedLanguage[2][8]}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                case 2:
                  return (
                    <div className="text-center">
                      <p className="font-weight-bold">
                        {selectedLanguage[3][0]}
                      </p>
                      <p className="text-muted small mb-2">
                        {selectedLanguage[3][1]}
                      </p>
                      <span
                        className="btn btn-blue d-block"
                        onClick={() =>
                          this.setState({
                            step: 3,
                            zone: "B",
                          })
                        }
                      >
                        {selectedLanguage[3][0]}
                      </span>
                      <div className="pt-2 text-center">
                        <p className="font-weight-bold">
                          {selectedLanguage[3][2]}
                        </p>
                        <p className="text-muted small mb-2">
                          {selectedLanguage[3][3]}
                        </p>
                      </div>
                      <span
                        className="btn btn-orange d-block"
                        onClick={() =>
                          this.setState({
                            step: 3,
                            zone: "O",
                          })
                        }
                      >
                        {selectedLanguage[3][2]}
                      </span>
                    </div>
                  );
                case 3:
                  return (
                    <div className="text-center">
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[4][0]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[4][1]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={
                              this.state.basicPlaces <= 1 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                basicPlaces:
                                  this.state.basicPlaces > 1
                                    ? this.state.basicPlaces - 1
                                    : 1,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">
                          {this.state.basicPlaces}
                        </span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={
                              this.state.basicPlaces >= 26 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                basicPlaces:
                                  this.state.basicPlaces < 26
                                    ? this.state.basicPlaces + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[4][2]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[4][3]}
                        </p>
                      </div>
                      <div className="mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.extraCar <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                extraCar:
                                  this.state.extraCar > 0
                                    ? this.state.extraCar - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">{this.state.extraCar}</span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.extraCar >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                extraCar:
                                  this.state.extraCar < 26
                                    ? this.state.extraCar + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <span
                          className="btn btn-primary"
                          onClick={() =>
                            this.setState({ step: false }, () =>
                              this.calculate()
                            )
                          }
                        >
                          {selectedLanguage[4][4]}
                        </span>
                      </div>
                    </div>
                  );
                case 4:
                  return (
                    <div className="text-center">
                      <p className="lead mb-3">{selectedLanguage[6][0]}</p>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[6][1]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[6][2]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={
                              this.state.carOrTrailer <= 0 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                carOrTrailer:
                                  this.state.carOrTrailer > 0
                                    ? this.state.carOrTrailer - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">
                          {this.state.carOrTrailer}
                        </span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={
                              this.state.carOrTrailer >= 26 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                carOrTrailer:
                                  this.state.carOrTrailer < 26
                                    ? this.state.carOrTrailer + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[6][3]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[6][4]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.caravan <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                caravan:
                                  this.state.caravan > 0
                                    ? this.state.caravan - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">{this.state.caravan}</span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.caravan >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                caravan:
                                  this.state.caravan < 26
                                    ? this.state.caravan + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[6][5]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[6][6]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.xxlCaravan <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                xxlCaravan:
                                  this.state.xxlCaravan > 0
                                    ? this.state.xxlCaravan - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">
                          {this.state.xxlCaravan}
                        </span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={
                              this.state.xxlCaravan >= 26 && "disabled"
                            }
                            size="lg"
                            onClick={() =>
                              this.setState({
                                xxlCaravan:
                                  this.state.xxlCaravan < 26
                                    ? this.state.xxlCaravan + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <div>
                        <p className="font-weight-bold">
                          {selectedLanguage[6][7]}
                        </p>
                        <p className="text-muted small">
                          {selectedLanguage[6][8]}
                        </p>
                      </div>
                      <div className="mt-1 mb-3">
                        <span>
                          <MDBIcon
                            icon="minus-circle text-muted clickable"
                            className={this.state.xxlCamper <= 0 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                xxlCamper:
                                  this.state.xxlCamper > 0
                                    ? this.state.xxlCamper - 1
                                    : 0,
                              })
                            }
                          />
                        </span>
                        <span className="mx-3 lead">
                          {this.state.xxlCamper}
                        </span>
                        <span>
                          <MDBIcon
                            icon="plus-circle text-muted clickable"
                            className={this.state.xxlCamper >= 26 && "disabled"}
                            size="lg"
                            onClick={() =>
                              this.setState({
                                xxlCamper:
                                  this.state.xxlCamper < 26
                                    ? this.state.xxlCamper + 1
                                    : 26,
                              })
                            }
                          />
                        </span>
                      </div>
                      <span
                        className="btn btn-primary d-block"
                        onClick={() =>
                          this.setState(
                            {
                              step: false,
                            },
                            () => this.calculate()
                          )
                        }
                      >
                        {selectedLanguage[6][9]}
                      </span>
                    </div>
                  );
                case false:
                  return (
                    <div className="text-center">
                      <p className="lead">{selectedLanguage[5][0]}</p>
                      <h2 className="text-red my-1 font-weight-bold">
                        {new Intl.NumberFormat(locale, {
                          style: "currency",
                          currency: "EUR",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(this.state.price ?? 0)}
                      </h2>
                      <p className="lea mb-3">{selectedLanguage[5][1]}</p>
                      <p className="text-muted small">
                        {selectedLanguage[5][2]}
                      </p>
                    </div>
                  );
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}
//#endregion

//#region > Exports
export default App;
//#endregion

/**
 * SPDX-License-Identifier: (EUPL-1.2)
 * Copyright © 2021 Christian Aichner
 */
